module.exports = __webpack_public_path__ + "img/picto-people.1e625565.svg";